import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/seo/SEOHead';
import { getBreadcrumbSchema } from '../../utils/structuredData';

export default function StudyoAsimMete() {
  const breadcrumbItems = [
    { name: 'Anasayfa', url: '/' },
    { name: 'Stüdyo Asım Mete', url: '/studyo-asim-mete' }
  ];

  return (
    <div className="bg-[#1c1612] min-h-screen">
      <SEOHead
        title="Stüdyo Asım Mete | Hakkımızda | İç Mimari Tasarım İstanbul"
        description="Studio Asım Mete, mekansal tasarımda minimalizm ve işlevselliği bir araya getiren, her projeye özgün bir yaklaşım sergileyen bir iç mimarlık stüdyosudur. İstanbul'da ofis, konut ve ticari mekan tasarımında uzman."
        keywords="studio asım mete, iç mimar istanbul, mimari tasarım stüdyosu, minimalist iç tasarım, lüks iç mimari, mekansal tasarım"
        canonical="/studyo-asim-mete"
        structuredData={getBreadcrumbSchema(breadcrumbItems)}
      />
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-[70vh] flex items-center justify-center overflow-hidden -mt-20 z-0">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=architectural%20studio%20workspace%20modern%20minimalist%20design%20office%20with%20concrete%20walls%20warm%20lighting%20professional%20atmosphere%20clean%20aesthetic%20sophisticated%20interior%20dark%20tones%20high%20end&width=1920&height=900&seq=studio-hero-bg&orientation=landscape')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-[#0e0c0a]/80 via-[#0e0c0a]/70 to-[#0e0c0a]/80"></div>
        </div>
        
        <div className="relative z-[60] text-center px-6 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-light text-white tracking-wider mb-6 font-serif uppercase">
            STUDIO ASIM METE
          </h1>
          <p className="text-lg md:text-xl text-white font-light leading-relaxed font-serif">
            Mekansal formda sessiz otorite
          </p>
        </div>
      </section>

      {/* About Section */}
      <section className="py-32 px-6 bg-[#0e0c0a]">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
            <div>
              <div className="space-y-6 text-white font-light text-lg leading-relaxed font-serif">
                <p>
                  Studio Asım Mete, mekansal tasarımda minimalizm ve işlevselliği bir araya getiren, 
                  her projeye özgün bir yaklaşım sergileyen bir iç mimarlık stüdyosudur.
                </p>
                <p>
                  Tasarımlarımızda gereksiz detaylardan arınmış, saf formlar ve malzeme dürüstlüğü 
                  ön plandadır. Her proje, kullanıcı deneyimini merkeze alan, zamansız ve sürdürülebilir 
                  çözümler sunar.
                </p>
                <p>
                  Mekânı dekor olarak görmüyor, onu bir pozisyon olarak ele alıyoruz. 
                  Azaltmak bizim için feragat değil, kontroldür.
                </p>
              </div>
            </div>
            <div className="relative h-[500px] rounded-sm overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=architectural%20designer%20portrait%20professional%20workspace%20modern%20minimalist%20studio%20interior%20concrete%20textures%20warm%20lighting%20sophisticated%20atmosphere%20clean%20aesthetic%20high%20end%20design&width=700&height=800&seq=studio-about-img&orientation=portrait"
                alt="Studio"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
